import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";

export const detailsData = (t, { data }) => [
  {
    head: t("gift_cards.details"),
    icon: icons?.details,
    details: [
      {
        label: "Card Name(EN)",
        name: data?.localized_data?.en?.name,
      },
      {
        label: "Card Name(AR)",
        name: data?.localized_data?.ar?.name,
      },
      {
        label: t("gift_cards.presentation"),
        name: data?.presentation,
      },
    ],
  },
  {
    head: t("gift_cards.prices"),
    icon: icons?.fees,
    details: [
      {
        label: t("gift_cards.price"),
        name: data?.price,
      },
      {
        label: t("gift_cards.price_after_discount"),
        name: data?.price_after_discount,
      },
    ],
  },
  {
    head: t("gift_cards.dates"),
    icon: icons?.dates,
    details: [
      {
        label: t("gift_cards.created_at"),
        name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
      },
      {
        label: t("gift_cards.updated_at"),
        name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
      },
    ],
  },
];
